import React, { useEffect, useState } from 'react';
import classes from "./HomePage.module.css";
import { FaChevronRight } from "react-icons/fa";
import { loginApi, unsubscribeApi, } from '../http/http';
import { FaBarsStaggered, FaXmark } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import Drawer from '../components/Drawer';
import CategoriesSection from '../components/CategoriesSection';
import { toast } from "react-toastify";
import { useSearchParams } from "react-router";
import { useLocation } from "react-router";




const HomePage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [drawer, setDrawer] = useState(false);
    const [msisdn, setMsisdn] = useState('');
    const [loading, setLoading] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [enteredMsisdn, setEnteredMsisdn] = useState("");
    const location = useLocation();

    console.log("msisdn", msisdn);

    const handleLogin = async (msisdn) => {
        

        try {
            setLoading(true)
            console.log("-------------------------------------------------")
            const res = await loginApi(msisdn);
            console.log(res, "homelogin------------");
            setLoading(false)

            if (res.status == 200) {
                console.log("--------------------hello")
                console.log(res?.data ,"daatttttttttttttttaaaaaaa");
                if(res?.data?.success == true){
                    console.log("chl gya------------------")
                toast.success(res.data?.msg);
                Cookies.set("user_msisdn", msisdn, { expires: 1 });
                console.log(res?.data,"datahomeloginapi");
                Cookies.set("user_id", res?.data?.user_id, {expires:1});
                searchParams.delete("t");
                navigate('/home');
                }
               
     }

        } catch (error) {
            setLoading(false)
            console.error("API error:", error);
            if (error.response?.status == 400) {
                toast.error(error.response?.data?.msg || "User not subscribed");
                navigate('/');
            } else {
                toast.error("Something went wrong. Please try again!");
            }
            navigate('/')
       }


    };

    useEffect(() => {
        const user_msisdn = searchParams.get("t")
      console.log(location?.state?.msisdn+"--------------msmsmsmsm")
       if (location?.state?.msisdn) {
        
         setMsisdn(location?.state?.msisdn);
             console.log("---------------------",msisdn)
         handleLogin(location?.state?.msisdn);
       }
       
       else if (!Cookies.get("user_msisdn") && user_msisdn) {
            console.log("msisdn -----------------", user_msisdn)
            handleLogin(user_msisdn)
        }
        else if (Cookies.get("user_msisdn")) {
            console.log("true--");
            console.log(Cookies.get("user_msisdn"), "msisdn from cookie")
            setMsisdn(Cookies.get("user_msisdn"))
        
        }
        else {

            setLoading(false)

            navigate("/");
        }
    }, [navigate, searchParams]);

    return (
        <>
            {loading ? <p>Loading...</p>
                :
                <main className={classes.main}>
                    <header className={classes.header}>
                        <nav className={classes.nav}>
                            <div className={classes.logo_container}>
                                <img src="/assets/images/logo.png" alt="logo" className={classes.logo} />
                            </div>

                            <div className={classes.nav_items}>
                                <button type="button" className={`${classes.nav_item} ${classes.active}`}>
                                    Home
                                </button>
                                <button type="button" className={classes.nav_item}
                                    onClick={() => {
                                        navigate("/category/rhymes");
                                    }}
                                >
                                    Categories
                                </button>
                                <button type="button" className={classes.nav_item}>
                                    Terms & Conditions
                                </button>
                                <button type="button" className={classes.nav_item_btn}
                                    onClick={() => {
                                        navigate("/category/rhymes");
                                    }}
                                >
                                    Watch Now
                                </button>
                                <button type="button" className={classes.nav_item_btn} onClick={() => setShowDialog(true)}  >
                                    Unsubscribe
                                </button>

                            </div>

                            <button type="button" className={classes.menu_bar}
                                onClick={() => {
                                    setDrawer(!drawer)
                                }}
                            >
                                {drawer ?
                                    <FaXmark
                                        className={classes.menu_bar_icon}
                                    />
                                    :
                                    <FaBarsStaggered className={classes.menu_bar_icon} />
                                }
                            </button>
                        </nav>
                    </header>

                    <section className={classes.section_landing_page}>
                        <div className={classes.grid_container}>
                            <div className={classes.grid_section_one}>
                                <h1 className={classes.heading_one}>
                                    <span className={classes.highlight_orange}>
                                        DIVE
                                    </span>{" "}
                                    INTO THE
                                </h1>
                                <h1 className={classes.heading_two}>
                                    GREATNESS OF </h1>
                                <h1 className={classes.heading_three}>
                                    <span className={classes.highlight_green}>
                                        LEARNING.
                                    </span>
                                </h1>

                                <p className={classes.portal_description}>
                                    Online educational platform for digital skills where students aged between 2-10 learn through fun and interactive videos
                                </p>

                                <button type="button" className={classes.watch_now_btn}
                                    onClick={() => {
                                        navigate("/category/rhymes");
                                    }}
                                >
                                    Watch Now <FaChevronRight className={classes.arrow_right} />
                                </button>

                                <div className={classes.grid_sub_container}>
                                    <div className={classes.kids_image_container}>
                                        <img src="/assets/images/kids.png" alt="kids" className={classes.kids_image} />
                                    </div>
                                    <div className={classes.kids_info}>
                                        <p className={classes.kids_info_text_one}>Made For</p>
                                        <p className={classes.kids_info_text_two}>- Kids</p>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.grid_section_two}>
                                <img src="/assets/images/kids-group.png" alt="kids-group" className={classes.kids_group_image} />
                            </div>

                        </div>
                        <img src="/assets/images/Union.png" alt="union" className={classes.union_image} />
                        <img src="/assets/images/learning.png" alt="union" className={classes.learning_image} />
                        {showDialog && (
                            <div className={classes.dialog_overlay}>
                                <div className={classes.dialog_box}>
                                    <p className={classes.label}>Enter Number to Unsubscribe</p>

                                   
                                    <input
                                        type="text"
                                        value={enteredMsisdn}
                                        onChange={(e) => setEnteredMsisdn(e.target.value)}
                                        placeholder="Enter Number"
                                        className={classes.input}
                                    />

                                    <div className={classes.dialog_buttons}>
                                      
                                        <button
                                            className={classes.cancel_btn}
                                            onClick={() => setShowDialog(false)}
                                        >
                                            Cancel
                                        </button>

                                       
                                        <button
                                            className={classes.sure_btn}
                                            onClick={async () => {
                                                try {
                                                                  
                                                    const user_id= Cookies.get("user_id")
                                                    const payload = {
                                                        user_id,
                                                        msisdn: enteredMsisdn,
                                                    };

                                                    const response = await unsubscribeApi(payload);
                                                    console.log("response from backend", response);

                                                    if (response?.data?.success) {
                                                        toast.success(response?.data?.msg);
                                                        Cookies.remove("user_msisdn");
                                                        Cookies.remove("user_id");
                                                        setShowDialog(false);
                                                        navigate(`/`);
                                                    } else {
                                                        toast.error(response?.data?.msg);
                                                    }
                                                } catch (error) {
                                                    toast.error("Something went wrong!");
                                                }
                                            }}
                                        >
                                            Unsubscribe
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}



                    </section>


                    <CategoriesSection />
                    <Drawer setDrawer={setDrawer} drawer={drawer} setShowDialog={setShowDialog} />

                </main>
            }


        </>

    )
}

export default HomePage;

const dummydata = [
    {
        image: ""
    }
]